// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1_Pfd","cls2":"Banner-cls2_I98 Banner-cls1_Pfd"};